<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144104' | translate }} {{ title | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144075' | translate}}</mat-label>
            <input matInput [readonly]="!isCreate" placeholder="{{'ml_144078' | translate}}" formControlName="apexId" (keyup)="onUserNameKeyUp($event)" />
          </mat-form-field>
        </div>
        <div class="col">
          <div class="mt-3">{{ editForm.controls["userName"].value }}</div>
          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144076' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="userName" />
          </mat-form-field> -->
        </div>
      </div>

      <div class="row mb-3">
        <div class="col">
          <app-user-profile-search-grid [filterText$]="userNameFilter$" (itemToggled)="onUserItemClicked($event)"></app-user-profile-search-grid>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143912' | translate}}</mat-label>
            <mat-select formControlName="country" (selectionChange)="countrySelectionChanged($event)" [disabled]="processing$ | async">
              @for (item of countrySelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143911' | translate}}</mat-label>
            <mat-select formControlName="subRegion_Id" (selectionChange)="subRegionSelectionChanged($event)" [disabled]="processing$ | async">
              @for (item of subRegionSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_144070' | translate)}}</mat-label>
            <mat-select formControlName="businessTypes" (selectionChange)="businessTypeSelectionChanged($event)" [disabled]="processing$ | async">
              @for (item of businessTypeSelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label| translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144113' | translate}}</mat-label>
            <mat-select formControlName="terminal_Ids" [disabled]="processing$ | async" multiple>
              @for (item of terminalSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_144103' | translate)}}</mat-label>
            <mat-select formControlName="role_id" [disabled]="processing$ | async" (selectionChange)="roleSelectionChanged($event)">
              @for (item of userProfileRoleSelectItems$ | async; track $index) {
              <mat-option [value]="item.role_Id">
                {{item.roleName | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
